const endpoints = {
  // login and profile module
  login: { url: "/login", method: "POST" },
  forgotPassword: { url: "/forgot-password", method: "POST" },
  updateUser: { url: "/profile", method: "POST" },
  getProfileDetails: { url: "/profile", method: "GET" },
  refreshToken: { url: "/refresh-token", method: "GET" },
  logout: { url: "/logout", method: "GET" },
  //FirstBanner
  updateAppBanner: { url: "/update-app-banner", method: "POST" },
  appBanner: { url: "/app-banner", method: "POST" },

  //second banner
  secondBannerList: { url: "/banner", method: "POST" },
  createSecondBanner: { url: "/create-banner", method: "POST" },
  secondBannerInfo: { url: "/banner-info", method: "POST" },
  manageSecondBanner: { url: "/manage-banner-order", method: "POST" },
  deleteSecondBanner: { url: "/delete-banner", method: "POST" },

  //third banner
  thirdBannerList: { url: "/banner-announcement", method: "POST" },
  createThirdBanner: { url: "/create-banner-announcement", method: "POST" },
  thirdBannerInfo: { url: "/banner-announcement-info", method: "POST" },
  manageThirdBanner: {
    url: "/manage-banner-announcement-order",
    method: "POST",
  },
  deleteThirdBanner: { url: "/delete-banner-announcement", method: "POST" },

  //forth banner
  forthBannerList: { url: "/banner-secondary", method: "POST" },
  createForthBanner: { url: "/create-banner-secondary", method: "POST" },
  deleteForthBanner: { url: "/delete-banner-secondary", method: "POST" },
  updateForthBanner: { url: "/update-banner-secondary", method: "POST" },
  forthBannerInfo: { url: "/banner-secondary-info", method: "POST" },
  manageForthBanner: { url: "/manage-banner-secondary-order", method: "POST" },

  //dashboard
  dashboardData: { url: "/dashboard", method: "POST" },
  ticketData: { url: "/ticket", method: "POST" },
  CreateTicket: { url: "/create-ticket", method: "POST" },
  ticketInfo: { url: "/ticket-info", method: "POST" },
  replyTicket: { url: "/reply-on-ticket", method: "POST" },
  updateTicketStatus: { url: "/update-ticket-status", method: "POST" },
  assignTicket: { url: "/assign-ticket", method: "POST" },
  uploadManager: { url: "/upload-manager", method: "POSTFORMDATA" },
  // location
  locationMaster: { url: "/location-master", method: "POST" },

  //role
  roleList: { url: "/role", method: "POST" },
  roleInfo: { url: "/role-info", method: "POST" },
  addRoleData: { url: "/create-role", method: "POST" },
  manageRoleStatus: { url: "/manage-role-status", method: "POST" },
  updateRoleData: { url: "/update-role", method: "POST" },
  permissionList: { url: "/permission", method: "POST" },
  // staff
  staffList: { url: "/staff", method: "POST" },
  staffInfo: { url: "/staff-info", method: "POST" },
  addStaffData: { url: "/create-staff", method: "POST" },
  manageStaffStatus: { url: "/manage-staff-status", method: "POST" },
  updateStaffData: { url: "/update-staff", method: "POST" },
  deleteStaffData: { url: "/delete-staff", method: "POST" },
  //dealers
  dealersList: { url: "/dealer", method: "POST" },
  dealersInfo: { url: "/dealer-info", method: "POST" },
  updateDealersData: { url: "/update-dealer", method: "POST" },
  uploadImageManager: { url: "/upload-manager", method: "POST" },
  dealersSalesReport: { url: "/dealer-sales-report", method: "POST" },
  // dealer and sub-dealer
  dealersPurchaseReport: { url: "/dealers-purchase-report", method: "POST" },
  //sub-dealers
  subDealersList: { url: "/sub-dealer", method: "POST" },
  SubDealersReportInfo: { url: "/sub-dealer-info", method: "POST" },
  updateSubDealersReportData: { url: "/update-sub-dealer", method: "POST" },
  subDealersSalesReport: { url: "/sub-dealer-sales-report", method: "POST" },
  //technicians
  techniciansList: { url: "/technician", method: "POST" },
  techniciansReportInfo: { url: "/technician-info", method: "POST" },
  updateTechniciansReportData: { url: "/update-technician", method: "POST" },
  techniciansPurchaseReport: {
    url: "/technician-purchase-report",
    method: "POST",
  },
  // for dealer sub-dealer and technician
  dealerRedeemableProductsReport: {
    url: "/dealers-redeemable-rewards-report",
    method: "POST",
  },
  //catalog
  catalogReportList: { url: "/catalog", method: "POST" },
  catalogReportInfo: { url: "/catalog-info", method: "POST" },
  createCatalogReport: { url: "/create-catalog", method: "POST" },
  deleteCatalogReport: { url: "/delete-catalog", method: "POST" },
  updateCatalogReportData: { url: "/update-catalog", method: "POST" },
  manageCatalogOrder: { url: "/manage-catalog-order", method: "POST" },
  //category
  categoryReportList: { url: "/category", method: "POST" },
  categoryReportInfo: { url: "/category-info", method: "POST" },
  updateCategoryReportData: { url: "/update-category", method: "POST" },
  addCategoryReportData: { url: "/create-category", method: "POST" },
  manageOrderData: { url: "/manage-achievers-order", method: "POST" },

  //tutorialvideo
  tutorialVideoList: { url: "/tutorial-video", method: "POST" },
  tutorialVideoInfo: { url: "/tutorial-video-info", method: "POST" },
  updateTutorialVideo: { url: "/update-tutorial-video", method: "POST" },
  addTutorialVideo: { url: "/create-tutorial-video", method: "POST" },
  deleteTutorialVideo: { url: "/delete-tutorial-video", method: "POST" },
  manageTutorialVideo: { url: "/manage-tutorial-video-order", method: "POST" },

  //CatalogVideo
  catalogVideoList: { url: "/catalog-video", method: "POST" },
  catalogVideoInfo: { url: "/catalog-video-info", method: "POST" },
  updateCatalogVideo: { url: "/update-catalog-video", method: "POST" },
  addCatalogVideo: { url: "/create-catalog-video", method: "POST" },
  deleteCatalogVideo: { url: "/delete-catalog-video", method: "POST" },
  manageCatalogVideo: { url: "/manage-catalog-video-order", method: "POST" },

  //startup_banner
  startupBannerList: { url: "/startup-banner", method: "POST" },
  startupBannerInfo: { url: "/startup-banner-info", method: "POST" },
  updateStartupBanner: { url: "/update-startup-banner", method: "POST" },
  addStartupBanner: { url: "/create-startup-banner", method: "POST" },
  deleteStartupBanner: { url: "/delete-startup-banner", method: "POST" },
  manageStartupBanner: { url: "/manage-startup-banner-order", method: "POST" },

  // reward
  scanRewardList: { url: "/scan-reward", method: "POST" },
  createScanReward: { url: "/create-scan-reward", method: "POST" },
  manageScanRewardStatus: { url: "/manage-scan-reward-status", method: "POST" },
  scanRewardInfo: { url: "/scan-reward-info", method: "POST" },
  updateScanReward: { url: "/update-scan-reward", method: "POST" },
  //bike reward
  createBikeReward: { url: "/create-bike-reward", method: "POST" },
  updateBikeReward: { url: "/update-bike-reward", method: "POST" },
  bikeRewardList: { url: "/bike-reward", method: "POST" },
  bikeRewardInfo: { url: "/bike-reward-info", method: "POST" },
  //points redeem options
  createPointsRedeemOptions: {
    url: "/create-points-redeem-options",
    method: "POST",
  },
  pointsRedeemOptionsList: {
    url: "/points-redeem-options-list",
    method: "POST",
  },
  pointsRedeemOptionsInfo: {
    url: "/points-redeem-options-info",
    method: "POST",
  },
  updatePointsRedeemOptions: {
    url: "/update-points-redeem-options",
    method: "POST",
  },
  deletePointsRedeemOptions: {
    url: "/delete-points-redeem-options",
    method: "POST",
  },
  // technicians first reward
  techniciansFirstRewardList: {
    url: "/technician-first-reward-list",
    method: "POST",
  },
  //dealer bonus points
  dealerBonusPointsReport: {
    url: "/dealer-bonus-points-report",
    method: "POST",
  },
  createDealerBonusPoints: {
    url: "/create-dealer-bonus-points",
    method: "POST",
  },
  updateDealerBonusPoints: {
    url: "/update-dealer-bonus-points",
    method: "POST",
  },
  deleteDealerBonusPoints: {
    url: "/delete-dealer-bonus-points",
    method: "POST",
  },
  // congratulation image upload
  congratulationsImageUploadList: {
    url: "/congratulations-image-upload-list",
    method: "POST",
  },
  createCongratulationsImageUpload: {
    url: "/create-congratulations-image-upload",
    method: "POST",
  },
  updateCongratulationsImageUpload: {
    url: "/update-congratulations-image-upload",
    method: "POST",
  },
  deleteCongratulationsImageUpload: {
    url: "/delete-congratulations-image-upload",
    method: "POST",
  },
  congratulationsImageUploadInfo: {
    url: "/congratulations-image-upload-info",
    method: "POST",
  },
  //admin add points old
  adminAddPointsOld: { url: "/admin-add-points-old", method: "POST" },
  createRewardPointAdminAddPoints: {
    url: "/create-reward-point-admin-add-points",
    method: "POST",
  },
  //inward outward list
  inwardOutwardList: { url: "/inward-outward-list", method: "POST" },
  //transfer history report
  transferHistoryReport: { url: "/wallet-transfer-history", method: "POST" },
  updateWalletTransferHistory: { url: "/wallet-transfer-history-update", method: "POST" },
  //other
  lockUserList: { url: "/lock-user", method: "POST" },
  updateLockUserData: { url: "/lock-unlock-user", method: "POST" },
  dropDownCategoryOptions: { url: "/drop_down", method: "POST" },
  //overall reward report
  overallRewardReport: { url: "/overall-reward-report", method: "POST" },
  //lucky draw report
  luckyDrawReport: { url: "/lucky-draw-report", method: "POST" },
  //otp report
  otpList: { url: "/otp-report", method: "POST" },
  //dealer replaced product
  dealerReplacedProduct: { url: "/dealer-replaced-product", method: "POST" },
  //bonus point report
  bonusPointReportList: { url: "/get-bonus-point-report", method: "POST" },
  createBonusPointReport: { url: "/create-bonus-point", method: "POST" },
  deleteBonusPointReport: { url: "/delete-bonus-point", method: "POST" },
  //cart report
  cartReport: { url: "/cart-report", method: "POST" },
  //scan code report
  scanCodeList: { url: "/scan-code-report", method: "POST" },
  // scan code manually
  scanCodeManually: { url: "/scan-code-manually", method: "POST" },
  //dealer additional warranty report
  DealerAdditionalWarrantyReport: {
    url: "/dealer-additional-warranty-report",
    method: "POST",
  },
  //dealer additional warranty replacement report
  dealerAdditionalWarrantyReplacementReport: {
    url: "/dealer-additional-warranty-replacement-report",
    method: "POST",
  },
  // master registration report list
  masterRegistrationReportList: {
    url: "/master-registration-report",
    method: "POST",
  },
  //whatsapp message report
  whatsAppMessageReportList: {
    url: "/whatsapp-notification-report",
    method: "POST",
  },
  //maintenancesetting
  systemMaintenanceList: { url: "/system-maintenance", method: "GET" },
  updateSystemMaintenance: { url: "/system-maintenance", method: "POST" },
  //whatsapp notification
  whatsappNotificationList: {
    url: "/whatsapp-notification-setting",
    method: "GET",
  },
  updateWhatsappNotification: {
    url: "/whatsapp-notification-setting",
    method: "POST",
  },
  // check user detail repor
  checkUserDetailReport: { url: "/check-user-detail-report", method: "POST" },
  monthwiseScanPercentageReport: {
    url: "/month-wise-scan-percentage-report",
    method: "POST",
  },
  bonusPointAchieverReport: {
    url: "/bonus-points-achievers-report",
    method: "POST",
  },
  overallRewardAchievedReport: {
    url: "/overall-reward-achieved",
    method: "POST",
  },
  overallPointAchievedReport: {
    url: "/overall-point-achieved",
    method: "POST",
  },
  overallRewardRedeemReport: {
    url: "/overall-reward-redeem",
    method: "POST",
  },
  overallBikeRewardReport: {
    url: "/overall-bike-reward-report",
    method: "POST",
  },
  accountLogDetailsReport: {
    url: "/account-log-details-report",
    method: "POST",
  },
  //auto notification setting
  autoNotificationList: { url: "/auto-notification-setting", method: "GET" },
  updateAutoNotification: { url: "/auto-notification-setting", method: "POST" },
  //outlate
  outlateList: { url: "/outlet", method: "POST" },
  updateOutlateStatus: { url: "/manage-outlet-status", method: "POST" },
  //lucky draw
  luckyDrawUser: { url: "/lucky-draw-user", method: "POST" },
  // point summary for dealer, sub dealer and technician
  pointSummaryList: { url: "/reward-point-summary", method: "POST" },
  // reward summary for dealer, sub dealer and technician
  rewardSummaryList: { url: "/reward-summary", method: "POST" },
  //verify-dealer-account
  verifyDealerAccountList: { url: "/verify-dealer-account", method: "POST" },
  //verify-sub-dealer-account
  verifySubDealerAccountList: {
    url: "/verify-sub-dealer-account",
    method: "POST",
  },
  //accept and reject
  approveRejectVerification: {
    url: "/approve-reject-verification",
    method: "POST",
  },
  //seminar
  seminarList: { url: "/seminar", method: "POST" },
  seminarInfo: { url: "/seminar-info", method: "POST" },
  seminarBookingList: { url: "/seminar-booking", method: "POST" },
  updateSeminarBookingRegistrationStatus: {
    url: "/update-seminar-registration",
    method: "POST",
  },
  addSeminarData: { url: "/create-seminar", method: "POST" },
  deleteSeminarData: { url: "/delete-seminar", method: "POST" },
  deleteSeminarBookingData: {
    url: "/delete-seminar-registration",
    method: "POST",
  },
  manageSeminarStatus: { url: "/manage-seminar-status", method: "POST" },
  updateSeminarData: { url: "/update-seminar", method: "POST" },
  //lucky draw campaign
  quarter2022JulSepList: { url: "/quarter-2022-jul-sep", method: "POST" },
  quarter2022OctDecList: { url: "/quarter-2022-oct-dec", method: "POST" },
  eligibleTechnicianLuckyDrawReport: {
    url: "/eligible-technician-lucky-draw-report",
    method: "POST",
  },
  eligibleTechnicianLuckyDrawReportOctDec: {
    url: "/eligible-technician-lucky-draw-report-oct-dec",
    method: "POST",
  },
  luckyDrawUserDetail: { url: "/lucky_draw_user_detail", method: "POST" },
  //Fult
  dealerToBeReplacementProduct: {
    url: "/dealer-to-be-replacement-product",
    method: "POST",
  },
  dealerToBeReplacementProductDetails: {
    url: "/dealer-to-be-replacement-product-details",
    method: "POST",
  },
  dealerToBeReplacementProductUpdate: {
    url: "/dealer-to-be-replacement-product-update",
    method: "POST",
  },
  technicianClaimedCompanyWarranty: {
    url: "/technician-claimed-company-warranty",
    method: "POST",
  },
  technicianClaimedCompanyWarrantyDetails: {
    url: "/technician-claimed-company-warranty-details",
    method: "POST",
  },
  productGivenWarranty: { url: "/product-given-warranty", method: "POST" },
  //manual notification
  manualNotificationList: { url: "/manual-notification", method: "POST" },
  addManualNotificationData: {
    url: "/create-manual-notification",
    method: "POST",
  },
  deleteManualNotificationData: {
    url: "/delete-manual-notification",
    method: "POST",
  },
  updateManualNotificationData: {
    url: "/update-manual-notification",
    method: "POST",
  },
  manualNotificationInfo: { url: "/manual-notification-info", method: "POST" },
  //fult type
  fultTypeList: { url: "/fault-type", method: "POST" },
  addFultTypeData: { url: "/create-fault-type", method: "POST" },
  deleteFultTypeData: { url: "/delete-fault-type", method: "POST" },
  updateFultTypeData: { url: "/update-fault-type", method: "POST" },
  FultTypeInfo: { url: "/fault-type-info", method: "POST" },

  //marquee type
  marqueeTypeList: { url: "/marquee", method: "POST" },
  addMarqueeData: { url: "/create-marquee", method: "POST" },
  deleteMarqueeData: { url: "/delete-marquee", method: "POST" },
  updateMarqueeData: { url: "/update-marquee", method: "POST" },
  marqueeInfo: { url: "/marquee-info", method: "POST" },

  //New report type
  newReportList: { url: "/whats-new", method: "POST" },
  addNewReportData: { url: "/create-whats-new", method: "POST" },
  deleteNewReportData: { url: "/delete-whats-new", method: "POST" },
  updateNewReportData: { url: "/update-whats-new", method: "POST" },
  newReportInfo: { url: "/whats-new-info", method: "POST" },
  updateNewReportStatus: { url: "/update-whats-new-status", method: "POST" },
  manageWhatsNewOrder: { url: "/manage-whats-new-order", method: "POST" },

  //terms and condition
  termsAndCondition: { url: "/terms-and-condition", method: "POST" },

  termsAndConditionGet: { url: "/terms-and-condition", method: "GET" },

  // reference schemas
  //fix scan reference
  fixScanReferenceReport: { url: "/fix-scan-reference-report", method: "POST" },
  createFixScanReferenceReport: {
    url: "/create-fix-scan-reference-report",
    method: "POST",
  },
  updateFixScanReferenceReport: {
    url: "/update-fix-scan-reference-report",
    method: "POST",
  },
  deleteFixScanReferenceReport: {
    url: "/delete-fix-scan-reference-report",
    method: "POST",
  },
  fixScanReferenceReportInfo: {
    url: "/fix-scan-reference-report-info",
    method: "POST",
  },
  // target points reference
  targetPointsReferenceReport: {
    url: "/target-points-reference-report",
    method: "POST",
  },
  createTargetPointsReferenceReport: {
    url: "/create-target-points-reference-report",
    method: "POST",
  },
  updateTargetPointsReferenceReport: {
    url: "/update-target-points-reference-report",
    method: "POST",
  },
  deleteTargetPointsReferenceReport: {
    url: "/delete-target-points-reference-report",
    method: "POST",
  },
  targetPointsReferenceReportInfo: {
    url: "/target-points-reference-report-info",
    method: "POST",
  },
  // milestone reference points
  milestoneReferencePointsReport: {
    url: "/milestone-reference-points-report",
    method: "POST",
  },
  createMilestoneReferencePointsReport: {
    url: "/create-milestone-reference-points-report",
    method: "POST",
  },
  updateMilestoneReferencePointsReport: {
    url: "/update-milestone-reference-points-report",
    method: "POST",
  },
  deleteMilestoneReferencePointsReport: {
    url: "/delete-milestone-reference-points-report",
    method: "POST",
  },
  milestoneReferencePointsReportInfo: {
    url: "/milestone-reference-points-report-info",
    method: "POST",
  },
  // level reference points
  levelReferencePointsReport: {
    url: "/level-reference-points-report",
    method: "POST",
  },
  createLevelReferencePointsReport: {
    url: "/create-level-reference-points-report",
    method: "POST",
  },
  updateLevelReferencePointsReport: {
    url: "/update-level-reference-points-report",
    method: "POST",
  },
  deleteLevelReferencePointsReport: {
    url: "/delete-level-reference-points-report",
    method: "POST",
  },
  levelReferencePointsReportInfo: {
    url: "/level-reference-points-report-info",
    method: "POST",
  },
  // achievement report
  levelReferenceAchievementReport: {
    url: "/level-reference-achievement-report",
    method: "POST",
  },
  fixScanAchievementReport: {
    url: "/fix-scan-achievement-report",
    method: "POST",
  },
  targetPointsAchievedPointsReport: {
    url: "/target-points-achieved-points-report",
    method: "POST",
  },
  milestonePointsAchievementReport: {
    url: "/milestone-points-achievement-report",
    method: "POST",
  },
  //role change
  userChangeRole: { url: "/change-user-role", method: "POST" },
  //delete users
  deleteUsers: { url: "/delete-user", method: "POST" },
  //social media setting
  socialMediaSettingList: { url: "/contact-setting", method: "GET" },
  updateSocialMediaSetting: { url: "/contact-setting", method: "POST" },
  // five star levels
  fiveStarLevels: { url: "/fivestar-levels", method: "POST" },
  fiveStarLevelInfo: { url: "/level-fivestar-info", method: "POST" },
  createFiveStarLevel: { url: "/create-fivestar-level", method: "POST" },
  updateFiveStarLevel: { url: "/update-fivestar-level", method: "POST" },
  deleteFiveStarLevel: { url: "/delete-fivestar-level", method: "POST" },
  allLevels: { url: "/all-levels", method: "POST" },
  // five star levels condition
  fiveStarLevelConditions: {
    url: "/fivestar-level-conditions",
    method: "POST",
  },
  fiveStarParentLevelConditions: {
    url: "/level-fivestar-condition-parent",
    method: "POST",
  },
  fiveStarLevelConditionInfo: {
    url: "/level-fivestar-condition-info",
    method: "POST",
  },
  createFiveStarLevelCondition: {
    url: "/create-fivestar-level-condition",
    method: "POST",
  },
  updateFiveStarLevelCondition: {
    url: "/update-fivestar-level-condition",
    method: "POST",
  },
  deleteFiveStarLevelCondition: {
    url: "/delete-fivestar-level-condition",
    method: "POST",
  },
  // five star gifts
  fiveStarGift: {
    url: "/fivestar-gift",
    method: "POST",
  },
  createFiveStarGift: {
    url: "/create-fivestar-gift",
    method: "POST",
  },
  updateFiveStarGift: {
    url: "/update-fivestar-gift",
    method: "POST",
  },
  deleteFiveStarGift: {
    url: "/delete-fivestar-gift",
    method: "POST",
  },
  fiveStarGiftInfo: {
    url: "/fivestar-gift-info",
    method: "POST",
  },
  // five star report
  fiveStarReport: {
    url: "/fivestar-report",
    method: "POST",
  },
  fiveStarReportExportCount: {
    url: "/export-fivestar-report-count",
    method: "POST",
  },
  fiveStarReportExportDownload: {
    url: "/export-fivestar-report-download",
    method: "POST",
  },
  fiveStarGiftReport: {
    url: "/fivestar-gift-report",
    method: "POST",
  },
  fiveStarGiftReportBulkWhatsappReport: {
    url: "/fivestar-gift-report-bulk-whatsapp",
    method: "POST",
  },
  fiveStarGiftReportBulkWhatsappMessagesReport: {
    url: "/fivestar-gift-report-bulk-whatsapp-message",
    method: "POST",
  },
  fiveStarGiftStickerDownload: {
    url: "/gift-sticker-generate",
    method: "POST",
  },
  importGiftReport: {
    url: "/import-tracking",
    method: "POSTFORMDATA",
  },
  scancodeExport: {
    url: "/export-scan-codes",
    method: "POST_BUFFER_DATA",
  },
  scancodeExportCount: {
    url: "/export-scan-codes-count",
    method: "POST",
  },
  scancodeExportDownload: {
    url: "/export-scan-codes-download",
    method: "POST",
  },
  globalSearchUser: {
    url: "/global-search-user",
    method: "POST",
  },
  globalSearchScanCode: {
    url: "/global-search-scan-code",
    method: "POST",
  },
  globalSearchUserPointSummary: {
    url: "/global-search-user-point-summary",
    method: "POST",
  },
  globalSearchUserFiveStarSummary: {
    url: "/global-search-user-five-star-summary",
    method: "POST",
  },
  globalSearchUserGiftPoints: {
    url: "/global-search-user-gift-points",
    method: "POST",
  },
  globalSearchUserLocation: {
    url: "/global-search-user-location",
    method: "GET",
  },
  globalSearchUserActivityStatus: {
    url: "/global-search-user-activity-summary",
    method: "POST"
  },
  globalSearchWarrantyReplacementProduct: {
    url: "/global-search-warranty-replacement-product",
    method: "POST",
  },
  // product scan reward report
  productScanRewardReportExport: {
    url: "/export-products-scan-rewards-excel-generator-download",
    method: "POST",
  },
  // master barcode 
  masterBarcodeReport: {
    url: "/masterbarcode-report",
    method: "POST",
  },
  masterBarcodeDetails: {
    url: "/masterbarcode-details",
    method: "POST",
  },
  masterBarcodeBalanceReport: {
    url: "/balance-report",
    method: "POST",
  },
  // store category
  storeCategoryList: {
    url: "/store-category",
    method: "POST",
  },
  storeCategoryInfo: {
    url: "/store-category-info",
    method: "POST",
  },
  storeCategoryCreate: {
    url: "/store-category/create",
    method: "POST",
  },
  storeCategoryUpdate: {
    url: "/store-category/update",
    method: "POST",
  },
  storeCategoryDelete: {
    url: "/store-category/delete",
    method: "POST",
  },

  // store product
  storeProductList: {
    url: "/store-product",
    method: "POST",
  },
  storeProductCreate: {
    url: "/store-product/create",
    method: "POST",
  },
  storeProductUpdate: {
    url: "/store-product/update",
    method: "POST",
  },
  storeProductDelete: {
    url: "/store-product/delete",
    method: "POST",
  },

  // wallet transaction
  walletBalanceList: {
    url: "/wallet-balance",
    method: "POST",
  },
  // referral used report
  referralUsedCoinReport: {
    url: "/referral-coin-used-report",
    method: "POST",
  },
  // wallet transaction
  walletTransactionList: {
    url: "/wallet-transaction-list",
    method: "POST",
  },
  importWalletTransaction: {
    url: "/import-wallet-transaction",
    method: "POSTFORMDATA",
  },
  addWalletTransaction: {
    url: "/add-wallet-transaction",
    method: "POST",
  },
  getUserByMobile: {
    url: '/get-user-by-mobile',
    method: "POST",
  }
};

export default endpoints;
